module.exports = __webpack_public_path__ + "static/media/setpsUsed.fc729dd8.svg";